import React, { useEffect, useState } from 'react';

export default function AutomationSmsRouting() {
  const [routes, setRoutes] = useState(null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    const abort = new AbortController();
    setRoutes(null); setError(false);
    fetch('/sender_ids.json', { headers: { Accept: 'application/json' }, signal: abort.signal })
      .then((response) => { if (!response.ok) throw new Error(); return response.json(); })
      .then((data) => setRoutes(data.initialSenderIds.filter((route) => route.provider_active)))
      .catch((err) => { if (err.name !== 'AbortError') setError(true); });
    return () => abort.abort();
  }, [revision]);

  const groups = (routes || []).reduce((all, route) => {
    if (!all[route.geo]) all[route.geo] = [];
    all[route.geo].push(route);
    return all;
  }, {});

  return <section className='automation-sms-routing' aria-label='SMS sender routing'>
    <header>
      <h4>SMS senders by GEO</h4>
      <button type='button' onClick={() => setRevision((value) => value + 1)}>Refresh</button>
    </header>
    <p>The player's GEO determines the sender at sending time. Lowest priority number goes first;
      equal priorities share traffic. Backups are used if the primary rejects the request.</p>
    <p>These are all active routes. Trigger and Filter determine which players enter this scenario.</p>
    {error ? <p role='alert'>Could not load SMS senders. Refresh to try again.</p>
      : routes === null ? <p role='status'>Loading SMS senders…</p>
        : routes.length === 0 ? <p role='status'>No active SMS routes. Configure a sender and GEO before sending.</p>
          : <div className='automation-sms-routing__table'>
            <table>
              <thead><tr>{['GEO', 'Sender', 'Sender ID', 'Priority', 'Role'].map((label) =>
                <th key={label} scope='col'>{label}</th>)}</tr></thead>
              <tbody>{Object.keys(groups).sort().flatMap((geo) => {
                const bindings = groups[geo].sort((a, b) => a.priority - b.priority || a.id - b.id);
                const primary = bindings[0].priority;
                const shared = bindings.filter((route) => route.priority === primary).length > 1;
                return bindings.map((route) => <tr key={route.id}>
                  <td>{geo}</td><td>{route.provider_name}</td><td>{route.value}</td>
                  <td className='automation-sms-routing__number'>{route.priority}</td>
                  <td>{route.priority === primary ? (shared ? 'Primary (shared)' : 'Primary') : 'Backup'}</td>
                </tr>);
              })}</tbody>
            </table>
          </div>}
    <p>Players whose GEO has no active route cannot receive SMS. Routing changes apply at sending time.</p>
    <a href='/sender_ids' target='_blank' rel='noopener noreferrer'>Manage SMS routing</a>
  </section>;
}
